import { z } from "zod";
export const ZRoomNumberingMethodKey = z
    .string()
    .min(1)
    .regex(/^[A-Z0-9_]+$/, "Room numbering method key must be uppercase snake case");
export const ZRoomNumberingMethod = z.object({
    key: ZRoomNumberingMethodKey,
    title: z.string().min(1),
    customer: z.string().min(1),
    pdfFileName: z.string().min(1),
    summary: z.string().min(1).optional(),
});
export const ROOM_NUMBERING_METHODS = [
    {
        key: "NRH",
        title: "NRH romnummerering",
        customer: "Sykehusbygg HF",
        pdfFileName: "NSD-8201-A-NO-0047 Romnummerering.pdf",
        summary: "Romnummerering basert på etasje, trapperom, korridoravstand og side av hovedakse.",
    },
];
export const ZRoomNumberingMethods = z.array(ZRoomNumberingMethod);
